import { Controller } from 'stimulus'
import 'nodelist-foreach-polyfill'

export default class extends Controller {
  static targets = ['wrap', 'image']

  loaded() {
    this.imageTargets.forEach((_image, _index) => {
      const _width = _image.clientWidth
      const _height = _image.clientHeight

      if (_width > _height) {
        this.wrapTargets[_index].classList.add('-landscape')
      } else {
        this.wrapTargets[_index].classList.add('-portrait')
      }
    })
  }
}